export const environment = {
    production: true,
    apiUrl: 'https://pxqyv7u3uc.execute-api.us-east-2.amazonaws.com/Prod/',
    rbacUrl: 'https://mkxz6glc13.execute-api.us-east-2.amazonaws.com/Prod/'
};
